import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { RegistrationService } from '../services/registration.service';
import { Action_StoreForgotPasswordDetails } from '../state/actions';
import { AWSCognitoErrorResponse } from '../models/error.model';
import { configureAmplify } from '../config/aws.config';
import { LookupService } from '../services/lookup.service';
import { SingleResultApiResponse } from '../models/api-response.model';
import { AWSSettings } from '../models/aws-settings.model';
import { AccessibilityService } from '../services/accessibility.service';


@Component({
  selector: 'online-app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
  host: {
    class:'full-view-port-component-with-no-side-nav'
  }
})
export class AuthComponent implements OnInit {


  constructor(
    private authService: AuthService,
    private registrationService: RegistrationService,
    private lookupService: LookupService,
    private router: Router,
    private store: Store<any>,
    private activatedRoute: ActivatedRoute,
    private accessibilityService: AccessibilityService) { }

  errorMessage: string;
  registrationConfirmationSuccessful = false;
  userAlreadyConfirmed = false;

  ngOnInit() {

    // Auth.configure(AuthConfig);
    const username = this.activatedRoute.snapshot.queryParamMap.get('username');

    const verificationCode = this.activatedRoute.snapshot.queryParamMap.get('verificationCode');

    const forgotPassword = this.activatedRoute.snapshot.queryParamMap.get('forgotPassword') === 'true';

    const isAgent = this.activatedRoute.snapshot.queryParamMap.get('isAgent') === 'true';

    const agentEmail = this.activatedRoute.snapshot.queryParamMap.get('email');



    //2020-03 No matter which module, always load AWS settings at begining!!

    this.lookupService.getAWSAuthSettings(isAgent)
      .subscribe((response: SingleResultApiResponse) => {

        if (response.Result) {

          const awsSettings: AWSSettings = {
            Region: response.Result.Region,
            UserPoolId: response.Result.UserPoolId,
            UserPoolWebClientId: response.Result.UserPoolWebClientId,
            IdentityPoolId: response.Result.IdentityPoolId,
            AuthenticationFlowType: response.Result.AuthenticationFlowType,
            BucketName: response.Result.BucketName
          };

          localStorage.setItem('awsSettings', JSON.stringify(awsSettings));

          configureAmplify(isAgent);
          

          //---------- Page/Module Logic -------
          
          if (forgotPassword && username && verificationCode) { //(1) Forgot password module

            this.store.dispatch({
              type: Action_StoreForgotPasswordDetails,
              payload: { username, verificationCode, isAgent, agentEmail }
            });
           
            this.accessibilityService.startloadingAccessibility();

            if (isAgent) {
              this.router.navigate(['/agent-reset-password']);
            }
            else {
              this.router.navigate(['/reset-password']);
            }
          }

          else if (username && verificationCode) { //(2) Activate user module!

            this.authService.confirmRegistration(username, verificationCode)
              .subscribe(data => {
                this.registrationService.verifyStudentRegistration(username)
                  .subscribe(() => {
                    this.registrationConfirmationSuccessful = true;
                  }, err => {
                    //console.log('Error while verifying the student');
                    this.errorMessage = err;
                  });

              }, (err: AWSCognitoErrorResponse) => {
                if (err.code === 'NotAuthorizedException') {
                  this.errorMessage = 'User is already been confirmed';
                  this.userAlreadyConfirmed = true;
                }
                console.log(err);
              });
          }
        }
      },

        err => {

          console.log('error happened while calling AWS Auth Settings');
        },

        () => {
        });

  }

  //show border when tab on link for accessibility
  linkTabAccessibility(event): void {
    event.style.outline = "1px solid black";
  }

  linkBlurAccessibility(event): void {
    event.style.outline = "";
  }



 
}
